export interface BankkarteFelder {
  iban: string;
  karteninhaber: string;
}

export const MOCK_BANKKARTE_FELDER: BankkarteFelder = {
  iban: 'DE89370400440532013000',
  karteninhaber: 'Max Mustermann',
};

/** Allowlist: only iban + karteninhaber are extracted — all other OCR fields are discarded. */
export function parseBankkarteOcrResponse(raw: Record<string, unknown>): BankkarteFelder {
  return {
    iban: raw.iban != null ? String(raw.iban) : '',
    karteninhaber: raw.karteninhaber != null ? String(raw.karteninhaber) : '',
  };
}

/**
 * Validates a German IBAN (DE format):
 * - Must be 22 characters
 * - Must start with "DE"
 * - Passes modulo-97 check
 */
export function validateDeIban(raw: string): boolean {
  const iban = raw.replace(/\s/g, '').toUpperCase();
  if (iban.length !== 22) return false;
  if (!iban.startsWith('DE')) return false;

  // Rearrange: move first 4 chars to end
  const rearranged = iban.slice(4) + iban.slice(0, 4);

  // Replace letters with numbers: A=10, B=11, ..., Z=35
  const numeric = rearranged.replace(/[A-Z]/g, ch => String(ch.charCodeAt(0) - 55));

  // Compute modulo 97 on the large integer (process in chunks to avoid overflow)
  let remainder = 0;
  for (const ch of numeric) {
    remainder = (remainder * 10 + parseInt(ch, 10)) % 97;
  }

  return remainder === 1;
}
